import { Entity } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import styles from './ThemeExposureTab.module.scss';
import { RankingMethodologySection } from './theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { ThemeExposureTable } from './theme-exposure-table/ThemeExposureTable';

export interface ThemeExposureTabProps {
  entity: Entity;
}

export const ThemeExposureTab = ({ entity }: ThemeExposureTabProps) => {
  return (
    <div className={styles.root} data-testid="theme-exposure-tab">
      <ErrorBoundaryWrapper
        fallback={
          <>
            <ErrorMessageWrapper
              className={styles.styledErrorMessageWrapper}
              displayIcon
            />
            <RankingMethodologySection rankingType={'companyToTheme'} />
          </>
        }
      >
        <ThemeExposureTable entity={entity} />
      </ErrorBoundaryWrapper>
    </div>
  );
};
